<template>
  <v-container class="pa-0">
    <v-row>
      <v-col class="py-0 px-2" cols="12" sm="6" md="3">
        <legend>Prestador</legend>
        <v-select
          :menu-props="{ bottom: true, offsetY: true }"
          flat
          solo
          dense
          label="Todos"
          :items="prestadoresFilter"
          v-model="formData.prestador_id"
          item-value="id"
          item-text="prest_nome"
          outlined
          @change="changePrestador()"
        ></v-select>
      </v-col>
      <v-col class="py-0 px-2" cols="12" sm="6" md="3">
        <legend>Operadora</legend>
        <v-select
          :menu-props="{ bottom: true, offsetY: true }"
          flat
          solo
          dense
          label="Todos"
          :items="operadorasFilter"
          v-model="formData.operadora_ans_id"
          item-value="id"
          item-text="oper_nome"
          outlined
        ></v-select>
      </v-col>
      <v-col class="py-0 pt-5 px-2" cols="12" sm="6" md="3">
        <v-text-field
          v-model="formData.search"
          prepend-inner-icon="mdi-magnify"
          placeholder="Filtrar por nº do lote"
          single-line
          outlined
          dense
          hide-details
          @keypress.enter="getListGrupos(formData)"
        ></v-text-field>
      </v-col>
      <v-col class="pt-5 px-1" cols="6" sm="6" md="3">
        <v-row class="d-flex">
          <v-btn
            color="primary"
            depressed
            height="30px"
            small
            class="px-2 ml-2"
            @click="getListGrupos(formData)"
            >Filtrar</v-btn
          >
          <v-btn
            outlined
            color="primary"
            depressed
            height="30px"
            small
            class="px-2 ml-2"
            @click="clearFilters()"
            >Limpar Filtro</v-btn
          >
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data() {
      return {
        formData: {
          search: '',
          operadora_ans_id: null,
          prestador_id: null,
          modulo_operadora: 'faturamento',
        },
        prestadoresFilter: [],
        operadorasFilter: [],
      };
    },
    methods: {
      clearFilters() {
        this.formData.search = '';
        this.formData.prestador_id =
          this.prestadores.length == 1 ? this.prestadores[0].id : null;
        this.formData.operadora_ans_id = null;
        this.getListGrupos(this.formData);
      },
      changePrestador() {
        this.getOperadoras(this.formData);
        this.formData.operadora_ans_id = null;
      },
    },
    props: {
      getListGrupos: Function,
      getOperadoras: Function,
      operadoras: Array,
      prestadores: Array,
    },
    mounted() {
      this.prestadoresFilter = Array.from(this.prestadores);
        if (this.formData.prestador_id != null) {
          this.getOperadoras(this.formData);
        }
      this.getListGrupos(this.formData);
    },
    watch: {
      prestadores: {
        deep: true,
        handler(val) {
          this.prestadoresFilter = Array.from(val);
          if (this.prestadoresFilter.length == 1) {
            this.formData.prestador_id = this.prestadoresFilter[0].id;
            this.getListGrupos(this.formData);
          } else {
            this.prestadoresFilter.unshift({
              id: null,
              prest_nome: 'Selecione',
            });
          }
        },
      },
      operadoras: {
        deep: true,
        handler(val) {
          this.operadorasFilter = Array.from(val);
        },
      },
    },
  };
</script>
